import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#005B53',
                error: '#b71c1c',
            },
        },
        icons: {
            iconfont: 'fa',
        }
    }
});
